/* JAILBIRD BOOKS — コレクション一覧「もっと見る」ボタン
   既存のページ送り（.pagination）を読み取り、次ページの商品を同じページに追記する。
   アプリ不要。テーマの絞り込み（Ajax）で一覧が差し替わっても自動で付け直す。 */
(function () {
  if (window.__jbLoadMore) return;
  window.__jbLoadMore = true;

  var GRID = '.collection-listing .product-grid';
  var ROW = '.pagination-row';

  function currentPage(row) {
    var cur = row.querySelector('.pagination__number.underline--not-link');
    var n = cur ? parseInt(cur.textContent, 10) : NaN;
    return isNaN(n) ? 1 : n;
  }

  function lastPage(row) {
    var max = 1;
    row.querySelectorAll('.pagination__number').forEach(function (el) {
      var n = parseInt(el.textContent, 10);
      if (!isNaN(n) && n > max) max = n;
    });
    return max;
  }

  function enhance() {
    var row = document.querySelector(ROW);
    var grid = document.querySelector(GRID);
    if (!row || !grid || row.dataset.jbEnhanced) return;
    row.dataset.jbEnhanced = '1';

    var next = row.querySelector('.pagination__next');
    var cur = currentPage(row);
    var last = lastPage(row);
    var shown = grid.querySelectorAll('.product-block').length;

    var wrap = document.createElement('div');
    wrap.className = 'jb-more';
    var status = '<p class="jb-more__status">' + shown + '冊を表示中' +
      (last > 1 ? '（' + cur + ' / ' + last + 'ページ）' : '') + '</p>';

    if (next) {
      wrap.innerHTML = status +
        '<a class="jb-more__btn" href="' + next.getAttribute('href') + '">もっと見る</a>';
    } else if (last > 1) {
      wrap.innerHTML = status + '<p class="jb-more__end">これで全部です</p>';
    } else {
      return;
    }
    row.insertBefore(wrap, row.firstChild);
  }

  function showAnimated(root) {
    root.querySelectorAll('[data-cc-animate]').forEach(function (el) {
      el.classList.add('cc-animate-init', 'cc-animate-in');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.jb-more__btn');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;

    var url = btn.getAttribute('href');
    btn.classList.add('is-loading');
    btn.textContent = '読み込み中…';

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector(GRID);
        var newRow = doc.querySelector(ROW);
        var grid = document.querySelector(GRID);
        var row = document.querySelector(ROW);
        if (!newGrid || !grid || !row) throw new Error('structure');

        var items = Array.prototype.slice.call(newGrid.children);
        var firstNew = null;
        items.forEach(function (item) {
          showAnimated(item);
          grid.appendChild(item);
          if (!firstNew) firstNew = item;
        });

        row.innerHTML = newRow ? newRow.innerHTML : '';
        delete row.dataset.jbEnhanced;
        enhance();

        // 商品ページから戻ったとき、近い位置に戻れるようURLを更新
        try { history.replaceState(history.state, '', url); } catch (err) {}

        // キーボード操作の人のため、追加分の先頭にフォーカス
        var link = firstNew && firstNew.querySelector('a');
        if (link) link.focus({ preventScroll: true });
      })
      .catch(function () {
        // うまく行かないときは普通に次ページへ移動
        window.location.href = url;
      });
  });

  // 初回 + 絞り込み・並べ替えで一覧が差し替わったとき
  enhance();
  new MutationObserver(function () { enhance(); })
    .observe(document.body, { childList: true, subtree: true });
})();
